import { useState, type ReactNode } from "react";
import { canUseCare } from "../../helpers/careEnabled";
import { createPortal } from "react-dom";
import { Card } from "reactstrap";
import { Link } from "react-router-dom";
// components Icons
import DashboardIcon from "../Components/Icons/DashboardIcon";
import OrganizationIcon from "../Components/Icons/OrganizationIcon";
import UserIcon from "../Components/Icons/UsersIcon";
import ArtformIcon from "../Components/Icons/ArtformIcon";
import SalesIcon from "../Components/Icons/SalesIcon";
import ProductionIcon from "../Components/Icons/ProductionIcon";
import IncomingIcon from "../Components/Icons/IncomingIcon";
import KarkhanaIcon from "../Components/Icons/KarkhanaIcon";
import CareIcon from "../Components/Icons/CareIcon";
import CustomFieldsIcon from "../Components/Icons/CustomFieldsIcon";
import CategoryIcon from "../Components/Icons/CategoryIcon";
import SubCategoryIcon from "../Components/Icons/SubCategoryIcon";
import ProductIcon from "../Components/Icons/ProductIcon";
import WeaveTypeIcon from "../Components/Icons/WeaveTypeIcon";
import TypeIcon from "../Components/Icons/TypeIcon";
import CatalogueIcon from "../Components/Icons/CatalogueIcon";
import CatalogIcon from "../../assets/images/icons8-catalog-50.png";
import { isStudioCatalogueNavPath } from "../../components/catalogue/cataloguePaths";
import GiRegistryIcon from "../Components/Icons/GiRegistryIcon";
import LoomsIcon from "../Components/Icons/LoomsIcon";
import PhysicalIdentityNavLink from "../../pages/physical-identity/PhysicalIdentityNavLink";
import CertificationsIcon from "../Components/Icons/CertificationsIcon";
import OrdersIcon from "../Components/Icons/OrdersIcon";
import { canUseGiRegistry } from "../../helpers/geoEnabled";
import { canUseOrders } from "../../helpers/orderEnabled";
import { canReceivePartnerOrders, canUseProductionNetwork } from "../../helpers/partnerNetworkEnabled";
import { canOpenKarkhana, isKarkhanaSupervisor } from "../../helpers/karkhanaEnabled";
import SupervisorMenu from "./SupervisorMenu";
import { canUseCatalogue } from "../../helpers/catalogueEnabled";
import { isTypeTagsEnabled } from "../../helpers/typeTagsEnabled";

const canHoverLabel = () =>
  typeof window !== "undefined" &&
  window.matchMedia("(hover: hover) and (pointer: fine)").matches;

const MiniNav = ({ children }: { children: ReactNode }) => {
  const [tip, setTip] = useState<{ label: string; top: number; left: number } | null>(null);
  const show = (target: EventTarget | null) => {
    const link = (target as HTMLElement | null)?.closest?.("a[data-tip]");
    if (!link) {
      return;
    }
    const box = link.getBoundingClientRect();
    setTip({
      label: link.getAttribute("data-tip") || "",
      top: box.top + box.height / 2,
      left: box.right + 8,
    });
  };
  return (
    <div
      className="parentListMini"
      onMouseOver={(event) => {
        if (canHoverLabel()) {
          show(event.target);
        }
      }}
      onMouseLeave={() => setTip(null)}
      onFocus={(event) => show(event.target)}
      onBlur={(event) => {
        if (!event.currentTarget.contains(event.relatedTarget as Node)) {
          setTip(null);
        }
      }}
    >
      {children}
      {tip
        ? createPortal(
            <div className="sidebar-mini-tip" style={{ top: tip.top, left: tip.left }}>
              {tip.label}
            </div>,
            document.body
          )
        : null}
    </div>
  );
};

const SideMiniCollaspe = (props: any) => {
  const { location, handleClick, authUser } = props;
  const showSettings =
    authUser?.users?.role === "SUPER_ADMIN" ||
    (authUser?.users?.role === "ORGANIZATION_ADMIN" &&
      process.env.REACT_APP_PERMISSIONS_ORG_ADMIN === "true") ||
    (authUser?.users?.role === "ORGANIZATION_MANAGER" &&
      process.env.REAC_APP_PERMISSIONS_ORG_MANAGER === "true");

  if (isKarkhanaSupervisor(authUser?.users?.role)) {
    return (
      <Card className="verticlemenuCardMini">
        <MiniNav>
          <SupervisorMenu location={location} expanded={false} />
        </MiniNav>
      </Card>
    );
  }

  return (
    <Card className="verticlemenuCardMini">
      <MiniNav>
        <Link
          to="/dashboard"
          className="studio-sidebar-product studio-sidebar-product--mini"
          aria-label="HastKalaPramanak home"
          data-tip="HastKalaPramanak"
        >
          HKP
        </Link>
        <Link to="/dashboard" data-tip="Dashboard" aria-label="Dashboard">
          <div
            className={
              location?.pathname === "/dashboard"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
            onClick={() =>
              handleClick({
                name: "dashboard",
              })
            }
          >
            <DashboardIcon />
          </div>
        </Link>
        <Link to="/products" data-tip="Products" aria-label="Products">
          <div
            className={
              location?.pathname === "/products" ||
              location?.pathname === "/createProduct" ||
              location.pathname.split("/")[1] === "view-product" ||
              location.pathname.split("/")[1] === "pre-viewProduct" ||
              location.pathname.split("/")[1] === "edit-product"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
            onClick={() => {
              handleClick({
                name: "products",
              });
            }}
          >
            <ProductIcon />
          </div>
        </Link>
        {canUseOrders(authUser?.users?.role) ? (
          <Link to="/orders" data-tip="Orders" aria-label="Orders">
            <div
              className={
                location?.pathname?.startsWith("/orders")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "orders",
                })
              }
            >
              <OrdersIcon />
            </div>
          </Link>
        ) : (
          ""
        )}
        {canUseOrders(authUser?.users?.role) ? (
          <Link to="/sales" data-tip="Sales" aria-label="Sales">
            <div
              className={
                location?.pathname?.startsWith("/sales")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "sales",
                })
              }
            >
              <SalesIcon />
            </div>
          </Link>
        ) : (
          ""
        )}
        {canUseProductionNetwork(authUser?.users?.role) ? (
          <Link to="/partner-network/board" data-tip="Production" aria-label="Production">
            <div
              className={
                location?.pathname?.startsWith("/partner-network/") && !location?.pathname?.startsWith("/partner-network/incoming")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "production",
                })
              }
            >
              <ProductionIcon />
            </div>
          </Link>
        ) : (
          ""
        )}
        {canReceivePartnerOrders(authUser?.users?.role) ? (
          <Link to="/partner-network/incoming" data-tip="Incoming" aria-label="Incoming">
            <div
              className={
                location?.pathname?.startsWith("/partner-network/incoming")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "incoming",
                })
              }
            >
              <IncomingIcon />
            </div>
          </Link>
        ) : (
          ""
        )}
        {canOpenKarkhana(authUser?.users?.role) ? (
          <Link to="/karkhana" data-tip="Karkhana" aria-label="Karkhana">
            <div
              className={
                location?.pathname === "/karkhana" || location?.pathname?.startsWith("/karkhana/")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "karkhana",
                })
              }
            >
              <KarkhanaIcon />
            </div>
          </Link>
        ) : (
          ""
        )}
        <Link to="/collector-access-requests" data-tip="Collector requests" aria-label="Collector requests">
          <div
            className={
              location?.pathname === "/collector-access-requests"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
            onClick={() => {
              handleClick({
                name: "collector-access-requests",
              });
            }            }
          >
            <ProductIcon />
          </div>
        </Link>
        {authUser?.users?.role === "SUPER_ADMIN" ? (
          // ||
          // (authUser?.users?.role === "ORGANIZATION_ADMIN" &&
          //   process.env.REACT_APP_PERMISSIONS_ORG_ADMIN === "true") ||
          // (authUser?.users?.role === "ORGANIZATION_MANAGER" &&
          //   process.env.REAC_APP_PERMISSIONS_ORG_MANAGER === "true")
          <>
            <Link to="/organisation" data-tip="Organizations" aria-label="Organizations">
              <div
                className={
                  location?.pathname === "/organisation"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "organisation",
                  })
                }
              >
                <OrganizationIcon />
              </div>
            </Link>
            <Link to="/nfc-tags" data-tip="HKP tags" aria-label="HKP tags">
              <div
                className={
                  location?.pathname === "/nfc-tags"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "nfc-tags",
                  })
                }
              >
                <ProductIcon />
              </div>
            </Link>
          </>
        ) : (
          ""
        )}
        {/* {(authUser?.users?.role === "ORGANIZATION_ADMIN" ||
          authUser?.users?.role === "ORGANIZATION_MANAGER") &&
        authUser?.users?.organizationResponse?.organizationType ===
          "Design Agency" ? (
          <Link to="/manufactures">
            <div
              className={
                location?.pathname === "/manufactures"
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
            >
              <OrganizationIcon />
            </div>
          </Link>
        ) : (
          ""
        )} */}
         {canUseCatalogue(authUser?.users?.role) ? (
          //   &&
          // authUser?.users?.organizationResponse?.organizationType ===
          //   "Manufacturer"
          <Link to="/catalogue" data-tip="Catalogue" aria-label="Catalogue">
            <div
              className={
                isStudioCatalogueNavPath(location?.pathname)
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "catalogue",
                })
              }
            >
              <CatalogueIcon />
            </div>
          </Link>
        ) : (
          ""
        )}
        {authUser?.users?.role === "ORGANIZATION_ADMIN" ||
        authUser?.users?.role === "ORGANIZATION_MANAGER" ? (
          //   &&
          // authUser?.users?.organizationResponse?.organizationType ===
          //   "Manufacturer"
          <Link to="/party" data-tip="Party" aria-label="Party">
            <div
              className={
                location?.pathname === "/party"
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
            >
              <OrganizationIcon />
            </div>
          </Link>
        ) : (
          ""
        )}
        <Link to="/users" data-tip="Users" aria-label="Users">
          <div
            className={
              location?.pathname === "/users" ||
              location?.pathname === "/createUser" ||
              location.pathname.split("/")[1] === "editUser" ||
              location.pathname.split("/")[1] === "viewUser"
                ? "verticleNameP verticleNamePOnclick"
                : "verticleNameP"
            }
            onClick={() =>
              handleClick({
                name: "users",
              })
            }
          >
            <UserIcon />
          </div>
        </Link>
        <PhysicalIdentityNavLink compact role={authUser?.users?.role} />
        {canUseGiRegistry(authUser?.users?.role) ? (
          <Link to="/gi-registry" data-tip="GI Registry" aria-label="GI Registry">
            <div
              className={
                location?.pathname?.startsWith("/gi-registry")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "gi-registry",
                })
              }
            >
              <GiRegistryIcon />
            </div>
          </Link>
        ) : (
          ""
        )}
        {canUseGiRegistry(authUser?.users?.role) ? (
          <Link to="/looms" data-tip="Looms" aria-label="Looms">
            <div
              className={
                location?.pathname?.startsWith("/looms")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "looms",
                })
              }
            >
              <LoomsIcon />
            </div>
          </Link>
        ) : (
          ""
        )}
        {canUseGiRegistry(authUser?.users?.role) ? (
          <Link to="/certifications" data-tip="Certifications" aria-label="Certifications">
            <div
              className={
                location?.pathname?.startsWith("/certifications")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() =>
                handleClick({
                  name: "certifications",
                })
              }
            >
              <CertificationsIcon />
            </div>
          </Link>
        ) : (
          ""
        )}
        {showSettings ? (
          <>
            <Link to="/artform" data-tip="Artforms" aria-label="Artforms">
              <div
                className={
                  location?.pathname === "/artform"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "artform",
                  })
                }
              >
                <ArtformIcon />
              </div>
            </Link>
            <Link to="/type" data-tip="Types" aria-label="Types">
              <div
                className={
                  location?.pathname === "/type"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "type",
                  })
                }
              >
                <TypeIcon />
              </div>
            </Link>
            <Link to="/category" data-tip="Category" aria-label="Category">
              <div
                className={
                  location?.pathname === "/category"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "category",
                  })
                }
              >
                <CategoryIcon />
              </div>
            </Link>
            <Link to="/sub-category" data-tip="Sub-Category" aria-label="Sub-Category">
              <div
                className={
                  location?.pathname === "/sub-category"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "sub-category",
                  })
                }
              >
                <SubCategoryIcon />
              </div>
            </Link>
            {isTypeTagsEnabled() ? (
              <Link to="/type-tags" data-tip="Type tags" aria-label="Type tags">
                <div
                  className={
                    location?.pathname === "/type-tags"
                      ? "verticleNameP verticleNamePOnclick"
                      : "verticleNameP"
                  }
                  onClick={() =>
                    handleClick({
                      name: "type-tags",
                    })
                  }
                >
                  <WeaveTypeIcon />
                </div>
              </Link>
            ) : null}
            <Link to="/weave-type" data-tip="Weave Types" aria-label="Weave Types">
              <div
                className={
                  location?.pathname === "/weave-type"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "weave-type",
                  })
                }
              >
                <WeaveTypeIcon />
              </div>
            </Link>
            <Link to="/process-master" data-tip="Process Master" aria-label="Process Master">
              <div
                className={
                  location?.pathname === "/process-master"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "process-master",
                  })
                }
              >
                <TypeIcon />
              </div>
            </Link>
            <Link to="/custom-fields" data-tip="Custom Fields" aria-label="Custom Fields">
              <div
                className={
                  location?.pathname === "/custom-fields"
                    ? "verticleNameP verticleNamePOnclick"
                    : "verticleNameP"
                }
                onClick={() =>
                  handleClick({
                    name: "custom-fields",
                  })
                }
              >
                <CustomFieldsIcon />
              </div>
            </Link>
            {canUseCare(authUser?.users?.role) && (
              <Link to="/care-templates" data-tip="Care Templates" aria-label="Care Templates">
                <div
                  className={
                    location?.pathname?.startsWith("/care-templates")
                      ? "verticleNameP verticleNamePOnclick"
                      : "verticleNameP"
                  }
                  onClick={() =>
                    handleClick({
                      name: "care-templates",
                    })
                  }
                >
                  <CareIcon />
                </div>
              </Link>
            )}
          </>
        ) : (
          ""
        )}
        {!showSettings && canUseCare(authUser?.users?.role) && (
          <Link to="/care-templates" data-tip="Care Templates" aria-label="Care Templates">
            <div
              className={
                location?.pathname?.startsWith("/care-templates")
                  ? "verticleNameP verticleNamePOnclick"
                  : "verticleNameP"
              }
              onClick={() => handleClick({ name: "care-templates" })}
            >
              <CareIcon />
            </div>
          </Link>
        )}
      </MiniNav>
    </Card>
  );
};

export default SideMiniCollaspe;
